
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autosusados",
      function () {
        return require("private-next-pages/autosusados/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autosusados"])
      });
    }
  